import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal } from "@fortawesome/pro-regular-svg-icons/faMedal";

export const Medal: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faMedal} {...props} />
);
